import { useMemo, useState } from "react";
import "./portfolio.css";

import WorkCard from "../../Components/card/WorkCard";
import AllWork from "../../data/work.json";

function Portfolio() {
  // Extract unique categories from workItems dynamically
  const categories = useMemo(() => {
    const cats = AllWork.workItems.map((item) => item.category);
    return ["All", ...Array.from(new Set(cats))];
  }, []);

  const [activeTab, setActiveTab] = useState("All");

  // Filter projects based on selected tab
  const filteredWork = useMemo(() => {
    if (activeTab === "All") return AllWork.workItems;
    return AllWork.workItems.filter((item) => item.category === activeTab);
  }, [activeTab]);

  return (
    <div className="portfolio">
      <div className="container">
        <div className="portfolioTitle">
          <h2 className="titleHead">Work List</h2>
          <p className="titleDoc">see the task</p>
        </div>

        {/* Tabs */}
        <div className="portfolioTabs">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`tabBtn ${activeTab === cat ? "active" : ""}`}
              onClick={() => setActiveTab(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Work Items */}
        <div className="allworkItems">
          {filteredWork
            .sort((a, b) => b.id - a.id)
            .map((workItem) => (
              <WorkCard key={workItem.id} workItem={workItem} />
            ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
